module.exports = __webpack_public_path__ + "assets/images/contact_us_middle_image.364947ac.png";